import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  overflow-x: auto;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
